import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface IMenuItem {
  type: string; // Possible values: link/dropDown/icon/separator/extLink
  name?: string; // Used as display text for item and title for separator type
  state?: string; // Router state
  icon?: string; // Material icon name
  tooltip?: string; // Tooltip text
  disabled?: boolean; // If true, item will not be appeared in sidenav.
  role_access?: string[];
  sub?: IChildItem[]; // Dropdown items
  badges?: IBadge[];
}
interface IChildItem {
  type?: string;
  name: string; // Display text
  state?: string; // Router state
  icon?: string;
  role_access?: string[];
  sub?: IChildItem[];
}

interface IBadge {
  color: string; // primary/accent/warn/hex color codes(#fff000)
  value: string; // Display text
}

@Injectable()
export class NavigationService {
  iconMenu: IMenuItem[] = [
    {
      name: 'DASHBOARD',
      type: 'link',
      tooltip: 'Início',
      icon: 'dashboard',
      state: 'dashboard/main'
    },
    {
      name: 'LIBERACAO',
      type: 'link',
      tooltip: 'Liberação',
      icon: 'lock',
      state: 'liberacao'
    },
    {
      name: 'UTILITARIOS',
      type: 'dropDown',
      tooltip: 'Utilitários',
      icon: 'settings',
      state: 'utilitario',
      sub: [
        {
          name: 'GERENCIADOR',
          type: 'link',
          icon: 'forward_to_inbox',
          state: 'gerencia'
        },
        {
          name: 'ASSINA',
          type: 'link',
          icon: 'description',
          state: 'assina'
        },
        {
          name: 'IMPORTA',
          type: 'link',
          icon: 'description',
          state: 'importa'
        },
        {
          name: 'TASK',
          type: 'link',
          icon: 'toc',
          state: 'task'
        },
        {
          name: 'PONTO_EQUILIBRIO',
          type: 'link',
          icon: 'equalizer',
          state: 'ponto-equilibrio'
        },
        {
          name: 'WHATSAPP_CONFIG',
          type: 'link',
          icon: 'whatsapp',
          state: 'whatsapp-config'
        },
        {
          name: 'CONFIGURAR_ATUALIZAR_CERTIFICADO_A1',
          type: 'link',
          icon: 'verified_user',
          state: 'empresas-certificado-a1'
        },
        {
          name: 'ASSINAR_INFOKAW',
          type: 'link',
          icon: 'credit_card',
          state: 'assinar-infokaw'
        },
        {
          name: 'NOTIFICACAO',
          type: 'link',
          icon: 'notifications',
          state: 'notificacao'
        },
        {
          name: 'BANNER',
          type: 'link',
          icon: 'photo_album',
          state: 'banner'
        }


      ]
    },

    {
      name: 'ACCESS',
      type: 'dropDown',
      tooltip: 'Shop',
      icon: 'vpn_key',
      state: 'profile',
      sub: [
        {
          name: 'AUTORIZATION',
          type: 'link',
          icon: 'lock',
          state: 'autoriza'
        },
        {
          name: 'TRASH',
          type: 'link',
          icon: 'delete',
          state: 'lixeira'
        }
      ]
    },
    {
      name: 'CADASTROS',
      type: 'dropDown',
      tooltip: 'Cadastros',
      icon: 'format_align_center',
      state: '',
      sub: [
        {
          name: 'CADASTROS_GERAIS',
          type: 'dropDown',
          icon: 'format_align_center',
          state: 'cad_cadastros',
          sub: [
            { name: 'CADASTRO_CONTATO', type: 'link', icon: 'lock', state: 'cadastro_contato'},
            { name: 'CADASTRO_GRUPO', type: 'link', icon: 'lock', state: 'cadastro_grupos'},
            { name: 'CADASTRO', type: 'link', icon: 'lock', state: 'cadastros'},
            { name: 'VEICULO', type: 'link', icon: 'truck', state: 'veiculos'},
            { name: 'CADASTRO_CIDADE', type: 'link', icon: 'lock', state: 'cidades'},
            { name: 'CADASTRO_TEXTO_ADICIONAL', type: 'link', icon: 'lock', state: 'texto_adicional'},
            { name: 'DF_CONTRA_CNPJ', type: 'link', icon: 'lock', state: 'df_contra_cnpj'},
          ]
        },
        {
          name: 'FATURAMENTO',
          type: 'dropDown',
          icon: 'format_align_center',
          state: 'cad_faturamento',
          sub: [
            { name: 'FATURAMENTO_PRODUTO', type: 'link', icon: 'lock', state: 'produtos'},
            { name: 'FATURAMENTO_PRODUTO_GRUPO', type: 'link', icon: 'lock', state: 'produto_grupos'},
            { name: 'FATURAMENTO_PRODUTO_UNIDADE', type: 'link', icon: 'lock', state: 'unidades'},
            { name: 'FATURAMENTO_PRODUTO_MARCA', type: 'link', icon: 'lock', state: 'marcas'},
            { name: 'FATURAMENTO_CONDPG', type: 'link', icon: 'lock', state: 'cond_pgto'},
          ]
        },
        {
          name: 'FINANCEIRO',
          type: 'dropDown',
          state: 'cad_financeiro',
          sub: [
            { name: 'FINANCEIRO_TIPO_COBRANCA', type: 'link', icon: 'lock', state: 'tipo_cobranca'},
            { name: 'FINANCEIRO_PORTADOR', type: 'link', icon: 'lock', state: 'portador'},
            { name: 'FINANCEIRO_BANCO', type: 'link', icon: 'lock', state: 'banco'},
            { name: 'FINANCEIRO_AGENCIA', type: 'link', icon: 'lock', state: 'agencia'},
            { name: 'FINANCEIRO_CLASSIFICACAO_GERENCIAL', type: 'link', icon: 'lock', state: 'classificacao_gerencial'},
            { name: 'FINANCEIRO_MOEDA', type: 'link', icon: 'lock', state: 'moeda'},
            { name: 'FINANCEIRO_CC', type: 'link', icon: 'lock', state: 'financ_cc'},
          ]
        },
      ]
    },
    {
      name: 'MOVIMENTACAO',
      type: 'dropDown',
      tooltip: 'Movimentações',
      icon: 'toc',
      state: '',
      sub: [
        {
          name: 'FATURAMENTO',
          type: 'dropDown',
          icon: 'format_align_center',
          state: 'fat_movto',
          sub: [
            { name: 'FATURAMENTO_LANCAMENTO', type: 'link', icon: 'lock', state: 'lancamentos'},
            { name: 'FATURAMENTO_MDFE', type: 'link', icon: 'lock', state: 'mdfe'},
            { name: 'FATURAMENTO_CTE', type: 'link', icon: 'lock', state: 'cte'},
          ]
        },
        {
          name: 'FINANCEIRO',
          type: 'dropDown',
          state: 'financ_movto',
          sub: [
            { name: 'FINANCEIRO_R', type: 'link', icon: 'lock', state: 'conta_rp/CREDITO'},
            { name: 'FINANCEIRO_P', type: 'link', icon: 'lock', state: 'conta_rp/DEBITO'},
            { name: 'FINANCEIRO_CC_MOVTO', type: 'link', icon: 'price_change', state: 'financ_cc_movto'},
          ]
        },
      ]
    }, 
    {
      name: 'MARKETPLACE',
      type: 'dropDown',
      tooltip: 'Marketplace',
      icon: 'store',
      state: 'marketplace',
      sub: [
        { name: 'MARKPARAMETER', state: 'parameter' },
      ]
    },
  {
    name: 'RELATORIO',
    type: 'dropDown',
    tooltip: 'Report',
    icon: 'report',
    state: 'relatorio',
    sub: [
      {
        name: 'LISTAGEM_CADASTROS',
        type: 'link',
        icon: 'lock',
        state: 'listagem_cadastros'
      },
      {
        name: 'COMPRAS_VENDAS',
        type: 'link',
        icon: 'lock',
        state: 'compra_venda'
      },
      {
        name: 'LISTAGEM_CONTAS_RECEBER_PAGAR',
        type: 'link',
        icon: 'lock',
        state: 'listagem_contas_receber_pagar'
      },
      {
        name: 'EXTRATO_CC',
        type: 'link',
        icon: 'lock',
        state: 'extrato_cc'
      },
      {
        name: 'APURACAO_RESULTADOS',
        type: 'link',
        icon: 'lock',
        state: 'apuracao_resultados'
      },
      {
        name: 'RAZAO_CLASSE_GERENCIAL',
        type: 'link',
        icon: 'lock',
        state: 'razao_classe_gerencial'
      },
      {
        name: 'LISTAGEM_PRODUTOS',
        type: 'link',
        icon: 'lock',
        state: 'listagem_produto'
      },
      {
        name: 'MOVTO_PRODUTOS',
        type: 'link',
        icon: 'lock',
        state: 'movto_produtos'
      },
      {
        name: 'LISTA_PRECO_RELATORIO',
        type: 'link',
        icon: 'lock',
        state: 'lista_preco_relatorio'
      },
      {
        name: 'INVENTARIO_PRODUTOS',
        type: 'link',
        icon: 'lock',
        state: 'inventario_produtos'
      },
      {
        name: 'LISTAGEM_CLASSIFICACAO_ABC',
        type: 'link',
        icon: 'lock',
        state: 'listagem_classificacao_abc'
      },
      {
        name: 'LISTAGEM_ETIQUETA_PRODUTO',
        type: 'link',
        icon: 'lock',
        state: 'listagem_etiqueta_produto'
      },

      // financeiro

    
      
      {
        name: 'LISTAGEM_SOLICITACOES',
        type: 'link',
        icon: 'lock',
        state: 'listagem_solicitacoes'
      },
      {
        name: 'LISTAGEM_SUGESTOES',
        type: 'link',
        icon: 'lock',
        state: 'listagem_sugestoes'
      },
      {
        name: 'LISTAGEM_CADASTROS',
        type: 'link',
        icon: 'lock',
        state: 'listagem_cadastros'
      },
    ]
  }
    // {
    //   name: "ECOMMERCE",
    //   type: "dropDown",
    //   tooltip: "Shop",
    //   icon: "shopping_cart",
    //   state: "shop",
    //   sub: [
    //     { name: "PRODUCTS", state: "" },
    //     { name: "PRODUCT DETAILS", state: "products/5a9ae2106f155194e5c95d67" },
    //     { name: "CART", state: "cart" },
    //     { name: "CHECKOUT", state: "checkout" }
    //   ]
    // }
  ]
  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle = 'Frequently Accessed';
  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.iconMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();

  constructor() { }

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {
    this.menuItems.next(this.iconMenu);
  }
}
